import React from 'react'

const Error = () => {
  return (
    <div className='flex h-screen justify-center items-center text-3xl text-red'>
        Error 404 not found
    </div>
  )
}

export default Error